<div class="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4">
  <div class="max-w-md w-full text-center">
    <!-- Maintenance Icon -->
    <div class="mx-auto mb-8">
      <svg class="w-24 h-24 text-green-600 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path>
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
      </svg>
    </div>

    <h1 class="text-4xl font-bold text-green-800 mb-4">We'll be back soon!</h1>
    
    <p class="text-lg text-gray-600 mb-8">
      We're currently performing some maintenance on our site to serve you better.
      Please check back in a little while.
    </p>

    <div class="bg-white p-4 rounded-lg shadow-sm border border-gray-200">
      <p class="text-sm text-gray-500">
        Estimated completion time:<br>
        <span class="font-semibold text-gray-700">30 minutes</span>
      </p>
    </div>
  </div>
</div>
